"use client";

import type { PropsWithChildren } from "react";
import { LocaleContext } from "~/app/[lang]/providers/LocaleContext";
import type { Config } from "~/i18n/config";

interface ProviderProps extends PropsWithChildren {
	lang: string;
	domain: Config["domains"][number];
}

export function LocaleProvider({ lang, domain, children }: ProviderProps) {
	return <LocaleContext.Provider value={{ lang, domain }}>{children}</LocaleContext.Provider>;
}
